import React from "react";

//Common Components

import Stack from "components/common/Stack";
import Box from "components/common/Box";
import SectionTitle from "components/SectionTitle";
import Text from "components/common/Text";

//Action Center Components
import JarvisOnestockStockCard from "components/JarvisOnestock/JarvisOnestockStockCard";

const OnestockActionCenterWebCard = (props) => {
  const {
    actionStockData,
    sellCall,
    buyCall,
    brokerList = [],
    isBrokerListLoading = 0,
    isBrokerListInitialCalled = 0,
    pendingAction,
    centrumReferalURL
  } = props;

  const stockItemCount = actionStockData?.stockData?.length || 0;
  const stockCardWidth = stockItemCount === 1 ? 1 : stockItemCount === 2 ? 0.5 : 0.33;

  return (
    <>
      {
        sellCall ?
          <Box sx={{ px: 3, pt: 2, pb: 2.5, width: "100%" }}>
            {actionStockData.brokerName ? (
              <Stack direction="row" justifyContent="space-between" mb={2}>
                <SectionTitle
                  sx={{ mb: 1.75 }}
                  heading={
                    <>
                      Broker ~
                      <Text
                        component="span"
                        color="#A2A7AE"
                        variant="subtitle2"
                        mx={1}
                      >
                        {actionStockData.brokerName}
                      </Text>
                    </>
                  }
                />
              </Stack>
            ) : null}

            <Stack
              direction="row"
              alignItems="stretch"
              justifyContent="flex-start"
              sx={{
                position: "relative",
                flexWrap: "wrap",
              }}
            >
              {actionStockData?.stockData.map((stockdetails, index) => {
                return (
                  <React.Fragment key={`stock_${index}`}>
                    <Stack
                      sx={{
                        flexGrow: 0,
                        width: { xs: 1, sm: stockCardWidth, md: stockCardWidth },
                      }}
                    >
                      <JarvisOnestockStockCard
                        stockDetails={stockdetails}
                        actionType={actionStockData.actionType}
                        data={actionStockData}
                        sellCall
                        brokerList={brokerList}
                        isBrokerListLoading={isBrokerListLoading}
                        isBrokerListInitialCalled={isBrokerListInitialCalled}
                        pendingAction={pendingAction}
                        centrumReferalURL={centrumReferalURL}
                      />
                    </Stack>
                  </React.Fragment>
                );
              })}
            </Stack>
          </Box>
          : null
      }
      {
        buyCall ?
          <Box sx={{ px: 3, pt: 2, pb: 2.5, width: "100%" }}>
            <Stack
              direction="row"
              alignItems="stretch"
              justifyContent="flex-start"
              sx={{
                position: "relative",
                flexWrap: "wrap",
              }}
            >
              {actionStockData?.stockData.map((stockdetails, index) => {
                return (
                  <React.Fragment key={`stock_${index}`}>
                    <Stack
                      sx={{
                        flexGrow: 0,
                        width: { xs: 1, sm: stockCardWidth, md: stockCardWidth },
                      }}
                    >
                      <JarvisOnestockStockCard
                        stockDetails={stockdetails}
                        data={actionStockData}
                        brokerList={brokerList}
                        isBrokerListLoading={isBrokerListLoading}
                        isBrokerListInitialCalled={isBrokerListInitialCalled}
                        pendingAction={pendingAction}
                        centrumReferalURL={centrumReferalURL}
                      />
                    </Stack>
                  </React.Fragment>
                );
              })}
            </Stack>
          </Box>
          : null
      }
    </>
  );
};
export default OnestockActionCenterWebCard;
